/**
 * Diary Quiz Set API (목록 조회 전용)
 * Company Admin은 세트를 생성/수정하지 않으므로 getDiaryQuizSets만 제공
 */
import { apiClient, ApiResponse } from './client'
import type { DiaryQuizSetSummaryResponse } from '@/types/diaryQuizSet'

/**
 * 세트 목록 조회
 */
export const getDiaryQuizSets = async (): Promise<DiaryQuizSetSummaryResponse[]> => {
    const response = await apiClient.get<ApiResponse<DiaryQuizSetSummaryResponse[]>>(
        '/diary-quiz-sets'
    )
    return response.data.data!
}
